const ready = (callback) => {

	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);

}


// Doc ready

ready(() => {

	// SMOOTH SCROLL TO ANCHORS

	const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"])');

	anchors.forEach(trigger => {

		trigger.onclick = function(e) {

			e.preventDefault();
			let hash = this.getAttribute('href');
			let target = document.querySelector(hash);
			let headerOffset = 0;
			let elementPosition = target.offsetTop;
			let offsetPosition = elementPosition - headerOffset;

			window.scrollTo({

				top: offsetPosition,
				behavior: 'smooth'

			});
		};
	});



	// BACK TO TOP

	//Get the button
	const topButton = document.getElementById('top');

	// When the user scrolls down 100px from the top of the document, show the button
	window.onscroll = function () {

		scrollFunction();

	};

	function scrollFunction() {
		if (
			document.body.scrollTop > 0 ||
			document.documentElement.scrollTop > 0
			) {

			topButton.style.display = 'block';

	} else {

		topButton.style.display = 'none';

	}
}

	// When the user clicks on the button, scroll to the top of the document
	topButton.addEventListener('click', backToTop);

	function backToTop() {

		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;

	}


	const swiperLogos = new Swiper('#swiperLogos', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		rewind: true,
		slidesPerView: 1,
		spaceBetween: 0,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 50
			}
		}
	});


	const swiperBoxes = new Swiper('#swiperBoxes', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		rewind: true,
		slidesPerView: 1,
		spaceBetween: 0,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 50
			}
		}
	});


	const swiperCases = new Swiper('#swiperCases', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		rewind: true,
		slidesPerView: 1,
		spaceBetween: 0
	});


});